import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=4b197c85"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/unique.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports